export const getUrlToken = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('token')
}